/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTypeAdditionalServiceUpdateReqVo
 */
export interface OrderTypeAdditionalServiceUpdateReqVo {
    /**
     * 订单类型
     * @type {number}
     * @memberof OrderTypeAdditionalServiceUpdateReqVo
     */
    orderType: number;
    /**
     * 订单类型的附加服务组id [1,2,3,4]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionalServiceUpdateReqVo
     */
    additionalServiceGroups: Array<number>;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof OrderTypeAdditionalServiceUpdateReqVo
     */
    enable: number;
    /**
     * 订单类型必选附加服务 [5,6,7,8]
     * @type {Array<number>}
     * @memberof OrderTypeAdditionalServiceUpdateReqVo
     */
    mustCheckServices?: Array<number>;
    /**
     * 仓库id
     * @type {number}
     * @memberof OrderTypeAdditionalServiceUpdateReqVo
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the OrderTypeAdditionalServiceUpdateReqVo interface.
 */
export function instanceOfOrderTypeAdditionalServiceUpdateReqVo(value: object): value is OrderTypeAdditionalServiceUpdateReqVo {
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('additionalServiceGroups' in value) || value['additionalServiceGroups'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function OrderTypeAdditionalServiceUpdateReqVoFromJSON(json: any): OrderTypeAdditionalServiceUpdateReqVo {
    return OrderTypeAdditionalServiceUpdateReqVoFromJSONTyped(json, false);
}

export function OrderTypeAdditionalServiceUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTypeAdditionalServiceUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderType': json['orderType'],
        'additionalServiceGroups': json['additionalServiceGroups'],
        'enable': json['enable'],
        'mustCheckServices': json['mustCheckServices'] == null ? undefined : json['mustCheckServices'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function OrderTypeAdditionalServiceUpdateReqVoToJSON(json: any): OrderTypeAdditionalServiceUpdateReqVo {
    return OrderTypeAdditionalServiceUpdateReqVoToJSONTyped(json, false);
}

export function OrderTypeAdditionalServiceUpdateReqVoToJSONTyped(value?: OrderTypeAdditionalServiceUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderType': value['orderType'],
        'additionalServiceGroups': value['additionalServiceGroups'],
        'enable': value['enable'],
        'mustCheckServices': value['mustCheckServices'],
        'warehouseId': value['warehouseId'],
    };
}

